module.exports = __webpack_public_path__ + "img/Icon-Visibility-Filled.16e9dc07.svg";